import { appConfig } from "App";
import axios from "axios";
import store from "redux/Store";

module = "/musicRuntime";
export const actionTypes = {
  LOADING: "LOADING" + module,
  LOAD: "LOAD" + module,
  ERROR: "ERROR" + module,
};

export const loadRuntime = (done) => {
  return async (dispatch) => {
    let orgID = JSON.parse(appConfig.ORG)?.code;
    
    try {
      const res = await axios.get(`${orgID}/orgruntime`);
      
      if (res.data) {
        dispatch({
          type: actionTypes.LOAD,
          payload: res.data,
        });
        if (done) done(res.data, null);
      } else {
        dispatch({
          type: actionTypes.ERROR,
          payload: { e: "runtimeError" },
        });
        if (done) done(null, "runtimeError");
      }

    } catch (err) {
      dispatch({
        type: actionTypes.ERROR,
        payload: { e: err.message || err },
      });
      if (done) done(null, err.message || "error");
    }
  };
};